const i = (e, t) => e.some(t);
function f(e, t, n = void 0) {
  for (const r in t)
    n ? i(e, n) || e.push(r) : e.indexOf(r) == -1 && e.push(r);
}
function p(e, t) {
  return e.reduce((n, r) => c(r, t) < c(n, t) ? r : n);
}
const a = (e, t) => e.reduce((n, r) => c(r, t) > c(n, t) ? r : n), c = (e, t) => {
  t = t.replace(/\[(\w+)]/g, ".$1"), t = t.replace(/^\./, "");
  const n = t.split(".");
  for (let r = 0, s = n.length; r < s; ++r) {
    const o = n[r];
    if (o in e)
      e = e[o];
    else
      return;
  }
  return e;
}, h = (e, t, n) => {
  let r = 0, s = e.length - 1, o = Math.floor((s + r) / 2);
  for (; n(t, e[o]) !== 0 && r < s; ) {
    const u = n(t, e[o]);
    u === -1 ? s = o - 1 : u === 1 && (r = o + 1), o = Math.floor((s + r) / 2);
  }
  return n(t, e[o]) === 0 ? [e[o], o] : void 0;
}, g = (e, t, n) => [
  ...e.filter(
    (r) => t.some((s) => !n(r, s))
  ),
  ...t
], l = (e, t = 1) => t > 0 ? e.reduce(
  (n, r) => n.concat(Array.isArray(r) ? l(r, t - 1) : r),
  []
) : e.slice(), d = (e, t) => {
  const n = /* @__PURE__ */ new Map();
  return e.forEach((r) => {
    const s = t(r), o = n.get(s);
    o ? o.push(r) : n.set(s, [r]);
  }), Array.from(n.values());
}, m = (e, t, n) => [
  // part of the array before the specified index
  ...e.slice(0, t),
  // inserted item
  n,
  // part of the array after the specified index
  ...e.slice(t)
], y = (e, t) => [
  // part of the array before the specified index
  ...e.slice(0, t),
  // part of the array after the specified index
  ...e.slice(t + 1)
], S = (e, t, n) => [
  // part of the array before the specified index
  ...e.slice(0, t),
  // inserted item
  n,
  // part of the array after the specified index
  ...e.slice(t + 1)
], w = (e, t) => [...e].sort(t), A = (e) => (t) => [...t].sort(e), I = {
  pushIfNotExist: f,
  inArray: i,
  smallest: p,
  largest: a,
  byString: c,
  binarySearch: h,
  replaceLeftWithRight: g,
  flatDeep: l,
  groupBy: d,
  insert: m,
  remove: y,
  replace: S,
  pureSort: w,
  curriedSort: A
};
export {
  h as binarySearch,
  c as byString,
  A as curriedSort,
  I as default,
  l as flatDeep,
  d as groupBy,
  m as insert,
  a as largest,
  w as pureSort,
  f as pushIfNotExist,
  y as remove,
  S as replace,
  g as replaceLeftWithRight,
  p as smallest
};
